// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// this toggler will either handle
// distance: km <-> mi
// or
// length: m <-> ft

export const getOptions = convertDistance => (
  [{
    label: convertDistance ? 'km' : 'm',
    value: 'SI',
  }, {
    label: convertDistance ? 'mi' : 'ft',
    value: 'US',
  }]
)
